export default __webpack_public_path__ + "static/2-b6dde5e0cd247f493d36aeea2f445360.jpeg";